const toFixedNoRounding = (num, n) => {
  const reg = new RegExp("^-?\\d+(?:\\.\\d{0," + n + "})?", "g");
  const a = num.toString().match(reg)[0];
  const dot = a.indexOf(".");
  if (dot === -1) {
    return a + "." + "0".repeat(n);
  }
  const b = n - (a.length - dot) + 1;
  return b > 0 ? a + "0".repeat(b) : a;
};

const toFloatFix = (num, n) => {
  const number = num.toString();
  num = parseFloat(num);

  if (
    parseFloat(num) === 0 ||
    parseFloat(num).toFixed(7) === 0.0 ||
    num.toFixed(7).toString() === "0.0000000"
  ) {
    return "0";
  } else if (parseFloat(num) % 1 != 0 && number.split(".")[1].length > n) {
    return toFixedNoRounding(num, n);
  } else {
    return number;
  }
};

export default { toFloatFix,toFixedNoRounding };
